import { HttpError, LoyaltyProgram } from '@rd/types';
import {
  RedeemCashLoyaltyProgramActions,
  RedeemCashLoyaltyProgramActionTypes,
} from '../actions/redeem-cash-loyalty-program.actions';

export interface RedeemCashLoyaltyProgramState {
  loading: boolean;
  error: HttpError | null;
  loyaltyPrograms: LoyaltyProgram[] | null;
}

const initialState: RedeemCashLoyaltyProgramState = {
  loading: false,
  error: null,
  loyaltyPrograms: null,
};

export function redeemCashLoyaltyProgramReducer(
  state: RedeemCashLoyaltyProgramState = initialState,
  action: RedeemCashLoyaltyProgramActions,
): RedeemCashLoyaltyProgramState {
  switch (action.type) {
    case RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM:
      return {
        ...state,
        loading: true,
      };

    case RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM_SUCCESS:
      return {
        ...state,
        loyaltyPrograms: action.payload,
        loading: false,
        error: null,
      };

    case RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM_FAILED:
      return {
        ...state,
        loyaltyPrograms: initialState.loyaltyPrograms,
        loading: false,
        error: action.payload,
      };
  }

  return state;
}
